var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckboxActive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    rx: 3.5,
    fill: "#8080FF",
    stroke: "#8080FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.00639 7.63323C4.80374 7.44565 4.48739 7.45787 4.29981 7.66052C4.11223 7.86317 4.12445 8.17952 4.3271 8.3671L5.00639 7.63323ZM7.5477 10.6668L7.20806 11.0338C7.30863 11.1269 7.44301 11.1746 7.57978 11.1658C7.71654 11.157 7.8437 11.0925 7.93153 10.9873L7.5477 10.6668ZM12.3839 5.65393C12.5609 5.44194 12.5325 5.12663 12.3205 4.94967C12.1085 4.7727 11.7932 4.80108 11.6163 5.01307L12.3839 5.65393ZM4.3271 8.3671L7.20806 11.0338L7.88734 10.2999L5.00639 7.63323L4.3271 8.3671ZM7.93153 10.9873L12.3839 5.65393L11.6163 5.01307L7.16387 10.3464L7.93153 10.9873Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxActive);
export default __webpack_public_path__ + "static/media/checkbox-active.9212f6fe55677a72297a7f0a51bef1d5.svg";
export { ForwardRef as ReactComponent };